import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDrop } from "react-dnd";
import { ItemTypes } from "../constants";

const ScrollingDropTarget = ({ children, containerRef }) => {
  const [scrollDirection, setScrollDirection] = useState(null);

  useEffect(() => {
    if (!scrollDirection) return;

    const scrollInterval = setInterval(() => {
      if (!containerRef.current) return;

      const mouseX = window.event?.clientX || 0;
      const scrollZoneSize = 500;

      const baseSpeed = 10;
      const maxSpeed = 30;

      if (scrollDirection === "left") {
        const distanceFromLeft = mouseX;
        const speedFactor = Math.max(0, 1 - distanceFromLeft / scrollZoneSize);
        const scrollAmount = -baseSpeed - maxSpeed * speedFactor;

        if (containerRef.current.scrollLeft > 0) {
          containerRef.current.scrollBy({
            left: scrollAmount,
            behavior: "auto"
          });
        }
      } else {
        const distanceFromRight = window.innerWidth - mouseX;
        const speedFactor = Math.max(0, 1 - distanceFromRight / scrollZoneSize);
        const scrollAmount = baseSpeed + maxSpeed * speedFactor;

        if (
          containerRef.current.scrollLeft <
          containerRef.current.scrollWidth - containerRef.current.clientWidth
        ) {
          containerRef.current.scrollBy({
            left: scrollAmount,
            behavior: "auto"
          });
        }
      }
    }, 30);

    return () => clearInterval(scrollInterval);
  }, [scrollDirection, containerRef]);

  const [, drop] = useDrop({
    accept: ItemTypes.SCHOOL,
    hover(item, monitor) {
      if (!containerRef.current) return;

      const clientOffset = monitor.getClientOffset();
      if (!clientOffset) return;

      const scrollZoneSize = 500;

      if (clientOffset.x < scrollZoneSize) {
        setScrollDirection("left");
      } else if (clientOffset.x > window.innerWidth - scrollZoneSize) {
        setScrollDirection("right");
      } else {
        setScrollDirection(null);
      }
    },
    drop() {
      setScrollDirection(null);
    }
  });

  drop(containerRef);

  return children;
};

ScrollingDropTarget.propTypes = {
  children: PropTypes.node.isRequired,
  containerRef: PropTypes.shape({
    current: PropTypes.any
  }).isRequired
};

export default ScrollingDropTarget;
